/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_RoundInputs */

const bn_game_round = /** @type {(inputs: Game_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রাউন্ড`)
};

const de_game_round = /** @type {(inputs: Game_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runde`)
};

const el_game_round = /** @type {(inputs: Game_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Γύρος`)
};

const en_game_round = /** @type {(inputs: Game_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Round`)
};

const es_game_round = /** @type {(inputs: Game_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ronda`)
};

const fr_game_round = /** @type {(inputs: Game_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manche`)
};

const hi_game_round = /** @type {(inputs: Game_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गोल`)
};

const hu_game_round = /** @type {(inputs: Game_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`forduló`)
};

const id_game_round = /** @type {(inputs: Game_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putaran`)
};

const it_game_round = /** @type {(inputs: Game_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giro`)
};

const ja_game_round = /** @type {(inputs: Game_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラウンド`)
};

const ko_game_round = /** @type {(inputs: Game_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`라운드`)
};

const nl_game_round = /** @type {(inputs: Game_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ronde`)
};

const pl_game_round = /** @type {(inputs: Game_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okrągły`)
};

const pt_game_round = /** @type {(inputs: Game_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rodada`)
};

const ru_game_round = /** @type {(inputs: Game_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Раунд`)
};

const sv_game_round = /** @type {(inputs: Game_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omgång`)
};

const tr_game_round = /** @type {(inputs: Game_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yuvarlak`)
};

const uk_game_round = /** @type {(inputs: Game_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Раунд`)
};

const vi_game_round = /** @type {(inputs: Game_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vòng`)
};

const zh_game_round = /** @type {(inputs: Game_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`轮`)
};

const zh_hant_game_round = /** @type {(inputs: Game_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`輪`)
};

/**
* | output |
* | --- |
* | "Round" |
*
* @param {Game_RoundInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_round = /** @type {((inputs?: Game_RoundInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_RoundInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_round(inputs)
	if (locale === "de") return de_game_round(inputs)
	if (locale === "el") return el_game_round(inputs)
	if (locale === "en") return en_game_round(inputs)
	if (locale === "es") return es_game_round(inputs)
	if (locale === "fr") return fr_game_round(inputs)
	if (locale === "hi") return hi_game_round(inputs)
	if (locale === "hu") return hu_game_round(inputs)
	if (locale === "id") return id_game_round(inputs)
	if (locale === "it") return it_game_round(inputs)
	if (locale === "ja") return ja_game_round(inputs)
	if (locale === "ko") return ko_game_round(inputs)
	if (locale === "nl") return nl_game_round(inputs)
	if (locale === "pl") return pl_game_round(inputs)
	if (locale === "pt") return pt_game_round(inputs)
	if (locale === "ru") return ru_game_round(inputs)
	if (locale === "sv") return sv_game_round(inputs)
	if (locale === "tr") return tr_game_round(inputs)
	if (locale === "uk") return uk_game_round(inputs)
	if (locale === "vi") return vi_game_round(inputs)
	if (locale === "zh") return zh_game_round(inputs)
	return zh_hant_game_round(inputs)
});